import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { ScrollArea } from 'src/@/components/ui/scroll-area';
import { Card, CardContent } from 'src/@/components/ui/card';
import { Badge } from 'src/@/components/ui/badge';
import { Separator } from 'src/@/components/ui/separator';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { mascararTel } from 'src/utils/functions';

export default function AiAnalyzeDetailsModal({ open, onClose, data }) {
  if (!data) return null;

  const getSentimentColor = (sentiment) => {
    const value = parseInt(sentiment);
    if (value >= 4) return "bg-green-100 text-green-800";
    if (value >= 3) return "bg-yellow-100 text-yellow-800";
    return "bg-red-100 text-red-800";
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">Detalhes da Análise</DialogTitle>
          <div className="text-sm text-gray-500">
            {format(new Date(data.date), "dd/MM/yyyy HH:mm", { locale: ptBR })}
          </div>
        </DialogHeader>

        <ScrollArea className="h-[calc(90vh-100px)]">
          <div className="space-y-6">
            {/* Cabeçalho com informações básicas */}
            <div className="grid grid-cols-3 gap-4">
              <Card>
                <CardContent className="pt-4">
                  <div className="text-sm text-gray-500">ID do Chat</div>
                  <div className="text-sm font-medium">{data.chat_id}</div>
                </CardContent>
              </Card>
              <Card>
                <CardContent className="pt-4">
                  <div className="text-sm text-gray-500">Telefone</div>
                  <div className="text-sm font-medium">{mascararTel(data.chat_phone)}</div>
                </CardContent>
              </Card>
              <Card>
                <CardContent className="pt-4">
                  <div className="text-sm text-gray-500">Sentimento</div>
                  <Badge 
                    className={`${getSentimentColor(data.result.sentiment)} px-3 py-1 rounded-full text-xs font-medium mt-1`}
                  >
                    {data.result.sentiment}/5
                  </Badge>
                </CardContent>
              </Card>
            </div>

            {/* Resumo */}
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold mb-3 text-gray-900">Resumo</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{data.result.resume}</p>
              </CardContent>
            </Card>

            {/* Assuntos */}
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold mb-3 text-gray-900">Assuntos</h3>
                <div className="grid grid-cols-2 gap-4">
                  {data.result.subject.map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2"></div>
                      <p className="text-sm text-gray-600">{item}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Alertas */}
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold mb-3 text-gray-900">Alertas</h3>
                <div className="grid grid-cols-2 gap-4">
                  {data.result.alerts.map((alert, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2"></div>
                      <p className="text-sm text-gray-600">{alert}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Sugestões */}
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-lg font-semibold mb-3 text-gray-900">Sugestões</h3>
                <div className="grid grid-cols-2 gap-4">
                  {data.result.suggestions.map((suggestion, index) => (
                    <div key={index} className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-gray-400 mt-2"></div>
                      <p className="text-sm text-gray-600">{suggestion}</p>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
} 